import { useQuery } from "@tanstack/react-query"
import { thumbnailApi } from "@/services/thumbnail-api"
import { queryKeys } from "./query-keys"
import { useAuthReady } from "./use-auth-ready"

/**
 * Fetch a dynamically generated report thumbnail.
 * Returns the raw Blob; callers are responsible for creating and revoking
 * object URLs via URL.createObjectURL / URL.revokeObjectURL.
 *
 * @param reportName - The report display name passed as `reportName` query param
 */
export function useThumbnail(reportName: string) {
  const isAuthReady = useAuthReady()

  return useQuery({
    queryKey: queryKeys.thumbnails.thumbnail(reportName),
    queryFn: () => thumbnailApi.getThumbnail(reportName),
    enabled: isAuthReady && !!reportName,
    staleTime: 5 * 60 * 1000,
  })
}
